<template>
    <el-dialog
        :title="(isForm ? (formId ? '编辑' : '添加岗位') : '查看') + dialogTitle"
        width="640px"
        :model-value="modelValue"
        @close="closed"
        :close-on-click-modal="false"
    >
        <el-form ref="formRef" :model="formData" :rules="formRules" label-width="120px" style="max-width: 540px">
            <el-form-item label="岗位名称" prop="name">
                <el-input v-if="isForm" v-model="formData.name" placeholder="请输入岗位名称"></el-input>
                <span v-else>{{ formData.name }}</span>
            </el-form-item>
            <el-form-item label="岗位编码" prop="code">
                <el-input v-if="isForm" v-model="formData.code" placeholder="请输入岗位编码"></el-input>
                <span v-else>{{ formData.code }}</span>
            </el-form-item>
            <el-form-item label="岗位顺序">
                <el-input-number
                    v-if="isForm"
                    v-model="formData.list_order"
                    class="mx-4"
                    :min="0"
                    :max="999999"
                    controls-position="right"
                />
                <span v-else>{{ formData.list_order }}</span>
            </el-form-item>
            <el-form-item label="岗位状态">
                <el-radio-group v-if="isForm" v-model="formData.status">
                    <el-radio :value="1">正常</el-radio>
                    <el-radio :value="0">停用</el-radio>
                </el-radio-group>
                <div v-else>{{ formData.status ? '正常' : '停用' }}</div>
            </el-form-item>
            <el-form-item label="备注" placeholder="请输入内容">
                <el-input v-if="isForm" v-model="formData.remark" type="textarea"></el-input>
                <div v-else>{{ formData.remark }}</div>
            </el-form-item>
        </el-form>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, ref, watch } from 'vue'
import { addPost, getPostDetail, putPost } from '@/api/post.js'
import { ElMessage } from 'element-plus'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    formId: {
        type: String,
        required: false
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])

// 表单源
const formData = ref({
    name: '',
    code: '',
    remark: '',
    list_order: 1,
    status: 1,
    visible: 1
})
// 验证规则

const formRules = ref({
    name: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入岗位名称'
        }
    ],
    code: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入岗位编码'
        }
    ]
})
const dialogTitle = ref('')
const submitLoading = ref(false)
const formRef = ref(null)
/**
 * 关闭
 */
const closed = () => {
    dialogTitle.value = ''
    emits('update:modelValue', false)
    formRef.value.resetFields()
}

/**
  确定按钮点击事件
 */

const onConfirm = async () => {
    if (!props.isForm) return
    if (props.formId !== '') {
        await doputPost()
    } else {
        await doaddPost()
    }
}

// 修改岗位
const doputPost = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        try {
            await putPost(formData.value)
            // 岗位修改成功
            emits('updateForm')
            ElMessage.success('修改成功！')
            submitLoading.value = false
            closed()
        } catch (error) {
            submitLoading.value = false
        }
    })
}

// 添加岗位
const doaddPost = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        try {
            await addPost(formData.value)
            emits('updateForm')
            ElMessage.success('添加成功！')
            submitLoading.value = false
            closed()
        } catch (error) {
            submitLoading.value = false
        }
        // 岗位添加成功
    })
}

// 获取岗位详情
const getPostDetailFun = async () => {
    const data = await getPostDetail(props.formId)
    formData.value = {
        name: data.name,
        code: data.code,
        remark: data.remark,
        list_order: data.list_order,
        status: data.status,
        visible: data.visible,
        id: data.id
    }
    dialogTitle.value = data.name
}

// 只有formId有的时候，才会去请求数据
watch(
    () => props.modelValue,
    (newVal) => {
        if (newVal && props.formId) {
            getPostDetailFun()
        } else {
            formData.value = {
                id: '',
                name: '',
                url: '',
                intro: '',
                list_order: 0,
                status: 1
            }
        }
    }
)
</script>

<style lang="scss" scoped></style>
